import React from "react";
import { PanelBody, ToggleControl, Button } from "@wordpress/components";
import { __ } from "@wordpress/i18n";
import { BControlPro } from "../../../../../../../wp-utils/v1/components";

const O3DVOptions = ({ attributes, setAttributes }) => {
  const { O3DVSettings, multiple, isPremium } = attributes;
  const { isFullscreen, isNavigation = false, isPagination = false, mouseControl } = O3DVSettings;

  const handleChange = (option) => {
    setAttributes({ O3DVSettings: { ...O3DVSettings, ...option } });
  };

  return (
    <PanelBody title={__("Options", "model-viewer")}>
      <ToggleControl label={__("Fullscreen", "model-viewer")} checked={isFullscreen} onChange={() => handleChange({ isFullscreen: !isFullscreen })} />

      <ToggleControl label={__("Mouse Control", "model-viewer")} checked={mouseControl} onChange={() => handleChange({ mouseControl: !mouseControl })} />

      {(multiple || !isPremium) && (
        <>
          <BControlPro isPremium={isPremium} Component={ToggleControl} label={__("show thumbnails list", "model-viewer")} checked={isPagination} onChange={() => handleChange({ isPagination: !isPagination })} />

          <BControlPro isPremium={isPremium} Component={ToggleControl} label={__("show arrow", "model-viewer")} checked={isNavigation} onChange={() => handleChange({ isNavigation: !isNavigation })} />
        </>
      )}
    </PanelBody>
  );
};

export default O3DVOptions;
